import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { ThemeProvider } from 'react-jss';
import { BrowserRouter as Router } from 'react-router-dom';
import Theme from './components/sidebar/resources/theme';
import App from './App';
import reportWebVitals from './reportWebVitals';
ReactDOM.render(
  <ThemeProvider theme={Theme}>
      <Router>
          <App/>
      </Router>
  </ThemeProvider>,
  document.getElementById('root')
);